import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import moment from 'moment';
import expirationMonthsCodes from '../modules/data/expiration-months-codes';
import { setExpirationMonth, setMonthsFromNow, setTodaysDate, resetAllExceptMonth, toggleMonthsAreLocked } from '../redux/modules/registration';
import monthsFromNowText from '../modules/monthsFromNow';

class ExpirationRow extends Component {
  constructor() {
    super();
    this.state = { monthMode: true };
    this.changeDate = this.changeDate.bind(this);
    this.forceMonth = this.forceMonth.bind(this);
  }

  getNumberMonthRow() {
    const { selectedMonthNumber, today, monthsFromNow, monthsAreLocked } = this.props;
    const fromNow = monthsFromNowText(today, selectedMonthNumber).replace(/\s+?months/, '');
    const months = fromNow.split('/').map(n => Number(n));

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((num) => {
      const key = `monthKey${num}`;
      const isActive = months.indexOf(num) > -1;
      const isHighlighted = isActive && Number(monthsFromNow) === num;

      const btnClass = classnames({
        Button: true,
        'MonthNumbers-button': true,
        'Button--selected': isHighlighted,
        'MonthNumbers--active': isActive,
        'MonthNumbers--activeLocked': !isActive && !isHighlighted && Number(monthsFromNow) === num,
        'MonthNumbers--disabled': monthsAreLocked && !isHighlighted && !isActive,
        'MonthNumbers--disabled--visible': !monthsAreLocked,
      });

      return (
        <button
          key={key}
          className={btnClass}
          onClick={() => {
            this.forceMonth(num);
          }}
        >{num}</button>
      );
    });
  }

  getModeButtons() {
    return (
      <div className="ExpiMode">
        <span className="ExpiMode-note">Mode: </span>
        <button
          id={'dobExpirationBtn'}
          className={`ExpiMode-btn ${this.state.monthMode ? 'ExpiMode-btn--selected' : ''}`}
          onClick={() => this.setState({ monthMode: true })}
        >DOB/Expiration</button>

        <button
          id={'forHireCoNameBtn'}
          className={`ExpiMode-btn ${this.state.monthMode ? '' : 'ExpiMode-btn--selected'}`}
          onClick={() => this.setState({ monthMode: false })}
        >For-Hire Co. Name</button>
      </div>
    );
  }

  forceMonth(num) {
    this.props.resetAllExceptMonth();
    this.props.setMonthsFromNow(num);
  }

  changeDate(event) {
    const date = event.target.value;
    this.props.resetAllExceptMonth();
    this.props.setTodaysDate(moment(date));
    this.props.setExpirationMonth(moment(date).month() + 1);
  }

  renderButtons() {
    return expirationMonthsCodes.map((item, i) => {
      const { month, code, tip, monthNum } = item;
      const label = this.state.monthMode ? month : code;
      const id = `ButtonMonth${i}`;

      const btnClass = classnames({
        Button: true,
        MonthButton: true,
        'Button--selected': this.props.selectedMonthNumber === monthNum,
      });

      return (
        <button
          key={id}
          className={btnClass}
          id={id}
          data-tooltip={tip}
          onClick={() => {
            this.props.setExpirationMonth(monthNum);
          }}
        >{label}
        </button>
      );
    });
  }

  getLockButton() {
    const { monthsAreLocked, toggleMonthsAreLocked } = this.props;
    const click = () => toggleMonthsAreLocked();
    if (monthsAreLocked) {
      return <button onClick={click} className="LockBtn LockBtn--locked"><i className="fa fa-lock LockBtn-icon" aria-hidden="true"></i></button>;
    }
    return <button onClick={click} className="LockBtn LockBtn--unlocked"><i className="fa fa-unlock-alt LockBtn-icon" aria-hidden="true"></i></button>;
  }

  render() {
    const monthNumbersClass = classnames({
      'MonthNumbers': true,
      'MonthNumbers--unlocked': !this.props.monthsAreLocked,
    });

    return (
      <div className="Box ExpiMode-wrapper">
        <div className="FCR-Datepicker-row">
        <label className="FCR-Datepicker-label">
        Purchase Date: 
        <input
        type="date"
        value={moment(this.props.today).format('yyyy-MM-DD')}
        className="FCR-Datepicker-input"
        onChange={this.changeDate}
        // dateFormat="MM/DD/YYYY"
        // todayButton="Today"
        onSelect={this.handleChangeRaw}
        />
      
        </label>
        </div>

        <div className="ExpiMode-top">
          {this.getModeButtons()}
        </div>

        <div className="ExpiMode-bottom clearfix">
          {this.renderButtons()}
          <div className={monthNumbersClass}>
            {this.getLockButton()}
            <span>Months: </span>
            {this.getNumberMonthRow()}
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedMonthNumber: state.registration.selectedMonthNumber,
    monthsFromNow: state.registration.monthsFromNow,
    today: state.registration.today,
    monthsAreLocked: state.registration.monthsAreLocked,
  };
};

export default connect(mapStateToProps, { setExpirationMonth, setMonthsFromNow, setTodaysDate, resetAllExceptMonth, toggleMonthsAreLocked })(ExpirationRow);
